import { z } from "zod";

export const mainMedicalCategoriesSchema = z.object({
  medicalCategories: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    })
  ),
});
